import React, { useState } from "react";
import classNames from "classnames";
import ss from "./FailedReason.module.css";

const FailedReasons = [
  { id: 1, reason: "对象不清晰" },
  { id: 2, reason: "对象错误" },
  { id: 3, reason: "动作错误" },
  { id: 4, reason: "人数错误" },
  { id: 5, reason: "颜色错误" },
  { id: 6, reason: "图案不完整" },
  { id: 7, reason: "遗漏店铺招牌" },
  { id: 8, reason: "缺少队伍成员" },
  { id: 9, reason: "超出比赛范围" },
];

export const FailedReason = (props) => {
  const { onClose, onConfirm } = props;
  const [selectedReason, setSelectedReason] = useState();

  return (
    <div className={ss.container}>
      <div className={ss.title}>请选择判定失败的原因</div>
      <div className={ss.reasonList}>
        {FailedReasons.map((reason) => {
          return (
            <div
              className={classNames(
                ss.resonItem,
                selectedReason === reason.id && ss.selected
              )}
              key={reason.id}
              onClick={() => setSelectedReason(reason.id)}
            >
              {reason.reason}
            </div>
          );
        })}
      </div>
      <div className={classNames(ss.btn, ss.close)} onClick={onClose}>
        关闭
      </div>
      <div
        className={classNames(
          ss.btn,
          ss.confirm,
          !selectedReason && ss.disabled
        )}
        onClick={() => onConfirm(selectedReason)}
      >
        确认
      </div>
    </div>
  );
};
